import type { IconNode } from '../types';

/**
 * @name glasses-square
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJtMi4yIDEzLjEgMy4xLTYuNEM1LjggNS43IDYuOCA1IDggNSIgLz4KICA8cmVjdCB3aWR0aD0iOCIgaGVpZ2h0PSI2IiB4PSIyIiB5PSIxMiIgcng9IjIiIC8+CiAgPHBhdGggZD0iTTE0IDE1YTIgMiAwIDAgMC00IDAiIC8+CiAgPHJlY3Qgd2lkdGg9IjgiIGhlaWdodD0iNiIgeD0iMTQiIHk9IjEyIiByeD0iMiIgLz4KICA8cGF0aCBkPSJtMjEuOCAxMy4xLTMuMS02LjRDMTguMiA1LjcgMTcuMiA1IDE2IDUiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/glasses-square
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const glassesSquare: IconNode = [
  ['path', { d: 'm2.2 13.1 3.1-6.4C5.8 5.7 6.8 5 8 5', key: '10wxgt' }],
  ['rect', { width: '8', height: '6', x: '2', y: '12', rx: '2', key: '1m6o96' }],
  ['path', { d: 'M14 15a2 2 0 0 0-4 0', key: '1oksg1' }],
  ['rect', { width: '8', height: '6', x: '14', y: '12', rx: '2', key: '29dzff' }],
  ['path', { d: 'm21.8 13.1-3.1-6.4C18.2 5.7 17.2 5 16 5', key: '1bnimr' }],
];

export default glassesSquare;
